const item = Object.freeze({
  SIFDE: 1,
  Inventory: 2,
});
export default item;
